export default __webpack_public_path__ + "static/illustration-content-title.url-8f497ba0ec00fc0f134fdd20c4c57723.svg";